"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddAdsetsToCampaignResponseToJSON = exports.AddAdsetsToCampaignResponseFromJSONTyped = exports.AddAdsetsToCampaignResponseFromJSON = exports.instanceOfAddAdsetsToCampaignResponse = void 0;
var runtime_1 = require("../runtime");
var CreateFullAdsetResponse_1 = require("./CreateFullAdsetResponse");
/**
 * Check if a given object implements the AddAdsetsToCampaignResponse interface.
 */
function instanceOfAddAdsetsToCampaignResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAddAdsetsToCampaignResponse = instanceOfAddAdsetsToCampaignResponse;
function AddAdsetsToCampaignResponseFromJSON(json) {
    return AddAdsetsToCampaignResponseFromJSONTyped(json, false);
}
exports.AddAdsetsToCampaignResponseFromJSON = AddAdsetsToCampaignResponseFromJSON;
function AddAdsetsToCampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSets': !(0, runtime_1.exists)(json, 'ad_sets') ? undefined : (json['ad_sets'].map(CreateFullAdsetResponse_1.CreateFullAdsetResponseFromJSON)),
    };
}
exports.AddAdsetsToCampaignResponseFromJSONTyped = AddAdsetsToCampaignResponseFromJSONTyped;
function AddAdsetsToCampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_sets': value.adSets === undefined ? undefined : (value.adSets.map(CreateFullAdsetResponse_1.CreateFullAdsetResponseToJSON)),
    };
}
exports.AddAdsetsToCampaignResponseToJSON = AddAdsetsToCampaignResponseToJSON;
